import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";

export default class extends Controller {
  static targets = [
    "refFilter",
    "propertyFilter",
    "fullNameFilter",
    "emailFilter",
    "dateFromFilter",
    "dateToFilter"
  ];

  connect() {
    const tableElement = $(this.element).find("#enquiries-table");

    this.dataTable = tableElement.DataTable({
      pageLength: 10,
      lengthMenu: [5, 10, 25, 50],
      order: [[7, "desc"]],
      dom:
        "<'row mb-3'<'col-sm-4'l><'col-sm-4'><'col-sm-4'f>>" +
        "<'row'<'col-12'tr>>" +
        "<'row mt-3'<'col-sm-5'i><'col-sm-7'p>>",
      language: { searchPlaceholder: "Search enquiries...", search: "" }
    });

    // Custom filtering
    $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
      if (settings.nTable !== tableElement[0]) return true;

      const cleanText = (html) => $("<div>").html(html).text().trim().toLowerCase();

      const rowRef = cleanText(data[0]);
      const rowFullName = cleanText(data[1]);
      const rowEmail = cleanText(data[2]);
      const rowProperty = cleanText(data[4]);
      const receivedAt = new Date(cleanText(data[7]));

      const refFilter = this.refFilterTarget.value.toLowerCase();
      const fullNameFilter = this.fullNameFilterTarget.value.toLowerCase();
      const emailFilter = this.emailFilterTarget.value.toLowerCase();
      const propertyFilter = this.propertyFilterTarget.value.toLowerCase();
      const dateFrom = this.dateFromFilterTarget.value;
      const dateTo = this.dateToFilterTarget.value;

      if (refFilter && !rowRef.includes(refFilter)) return false;
      if (fullNameFilter && !rowFullName.includes(fullNameFilter)) return false;
      if (emailFilter && !rowEmail.includes(emailFilter)) return false;
      if (propertyFilter && !rowProperty.includes(propertyFilter)) return false;

      if (dateFrom && receivedAt < new Date(dateFrom)) return false;
      if (dateTo && receivedAt > new Date(dateTo)) return false;

      return true;
    });

    // Listeners
    this.refFilterTarget.addEventListener("keyup", () => this.refresh());
    this.fullNameFilterTarget.addEventListener("keyup", () => this.refresh());
    this.emailFilterTarget.addEventListener("keyup", () => this.refresh());
    this.propertyFilterTarget.addEventListener("keyup", () => this.refresh());
    this.dateFromFilterTarget.addEventListener("change", () => this.refresh());
    this.dateToFilterTarget.addEventListener("change", () => this.refresh());

    // 🔹 Listen for Turbo Stream appended rows
    this.element.addEventListener("turbo:append", (event) => {
      // Only redraw if the appended element is part of our table body
      if (event.target.closest("#enquiries_list")) {
        // Tell DataTables to re-index its rows
        this.dataTable.rows().invalidate().draw();
      }
    });
  }

  refresh() {
    this.dataTable.draw();
  }

  clearFilters() {
    this.refFilterTarget.value = "";
    this.fullNameFilterTarget.value = "";
    this.emailFilterTarget.value = "";
    this.propertyFilterTarget.value = "";
    this.dateFromFilterTarget.value = "";
    this.dateToFilterTarget.value = "";

    this.dataTable.search("");
    this.dataTable.draw();
  }
}
